import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { throttle } from 'lodash';

import CloseButton from 'presentation/containers/CloseButtonContainer';
import IconContainer from 'presentation/components/icons/IconContainer';
import { navigateBack } from 'app/modules/ui/actions';
import overrideStyle from 'lib/overrideStyle';

const HeaderWrapper = overrideStyle('div')`
  border-radius: 10px 10px 0px 0px;
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
`;

const Title = overrideStyle('div')`
  display: flex;
  font-size: 18px;
  font-weight: 500;
  width: 100%;
`;

const CloseButtonWrapper = overrideStyle('div')`
  height: 13px;
  width: 13px;
`;

const Back = overrideStyle('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  & svg {
    height: 15px;
    margin-right: 8px;
  }
`;

export function Header(props) {
  const chevron = (
    <IconContainer viewBox="0 0 256 512">
      <path
        fill="currentColor"
        d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
      />
    </IconContainer>
  );
  const onClick = throttle(props.onNavigateBack, 1000);

  return (
    <HeaderWrapper>
      {props.shouldDisplayBackButton ? <Back onClick={onClick}>{chevron} Back</Back> : <Title>{props.title}</Title>}
      <CloseButtonWrapper>
        <CloseButton />
      </CloseButtonWrapper>
    </HeaderWrapper>
  );
}

Header.propTypes = {
  onNavigateBack: PropTypes.func,
  shouldDisplayBackButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    onNavigateBack: () => {
      dispatch(navigateBack());
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Header);
